import { Link } from "react-router-dom";
import { stats } from "@/mocks/gua";

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20warm%20illustration%20of%20floating%20water%20lily%20pads%20and%20melon%20slices%20turning%20into%20speech%20bubbles%20on%20a%20deep%20terracotta%20background%2C%20editorial%20poster%20texture%2C%20grainy%20retro%20print%20style%2C%20rich%20warm%20tones&width=1600&height=900&seq=gua-hero-main&orientation=landscape"
          alt="蝌蚪吃瓜 品牌主视觉：睡莲、西瓜与聊天气泡组成的插画"
          title="蝌蚪吃瓜 - 合集补档与考古旧瓜精选"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>

      <div className="relative mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur">
          <i className="ri-sparkling-2-line"></i>
          全系列考古旧瓜精选集 · 持续补档中
        </span>

        <h1 className="mt-6 font-display text-4xl leading-tight text-background-50 md:text-6xl">
          蝌蚪吃瓜
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-50/85 md:text-lg">
          所有错过的瓜，这里全部都能翻到。历史名场面完整收录，随时回看补课，
          老瓜新吃一次看个够。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <Link
            to="/heji"
            className="flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-book-shelf-line"></i>
            翻合集补课
          </Link>
          <Link
            to="/heji?sort=new"
            className="flex items-center gap-2 rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 whitespace-nowrap"
          >
            <i className="ri-time-line"></i>
            查看最新补档
          </Link>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-4 md:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-background-50/20 bg-background-50/10 px-4 py-4 backdrop-blur"
            >
              <dt className="text-xs text-background-50/70">{s.label}</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-background-50 md:text-2xl">
                {s.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}